// extracted by mini-css-extract-plugin
export default {"productMainPrice":"ProductMainPrice-productMainPrice-Up4"};